import React from 'react'
import {getDashboardCompetitionList, getDashboardCompetition,getArtikelTags} from 'actions'
import {Divider, IconButton, useTheme, Button, Card,makeStyles} from '@material-ui/core'
import {VideogameAssetOutlined} from '@material-ui/icons'
import {history} from "store"
import CustomScrollbars from './CustomDashboardScrollbar'
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';
import DashBoardTavlingItem from './DashboardTavlingItem'
import {useSelector, useDispatch} from 'react-redux'
import {ArrowForwardIos, ArrowBackIos} from '@material-ui/icons'
import { isEmpty, isUndefined } from 'lodash'
import moment from 'moment'
import DashboardBG from '../../../../../DashboardComponentsV2/Images/notyfile_dashboard_bg.svg'
import IntlMessages from 'util/IntlMessages';
const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const useStyles = makeStyles({
  tavlingBg: {
    backgroundImage: `url(${DashboardBG})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height:'100%'
  }
});

export default function DashboardTävlingar(props) {
  const dispatch = useDispatch()
  const classes = useStyles();
  const DashboardCompetitionList = useSelector(state => state.DashBoard.DashboardCompetitionList)
  const DashboardCompetitionLoading = useSelector(state => state.DashBoard.DashboardCompetitionLoading)
  const currentDashboardCompetition = useSelector(state => state.DashBoard.currentDashboardCompetition)
  const Userid = useSelector(state => state.auth.authUser.user_id)
  const Afid = useSelector(state => state.auth.authUser.user_Afid)

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [currentDashboardState, setCurrentDashboardState] = React.useState({})
  const [isRefreshed, setisRefreshed] = React.useState(false)
  React.useEffect(()=>{
    setisRefreshed(true)
  },[props])
  React.useEffect(()=>{
    if(isRefreshed === true){
    setTimeout(() => {
      setisRefreshed(false)
    }, 1000);    
    }
  },[isRefreshed])

	const ShouldDisplay = (comp)=>{
		return moment(comp.compEnd).add(1, 'month').diff(moment(), 'days') > 0 || parseInt(comp.Finished) === 0
	}

  const handleStepChange = (step) => {
    // console.log(step)
    if(!isEmpty(DashboardCompetitionList)) {
      let fetchThisDashboard = DashboardCompetitionList.filter(d => ShouldDisplay(d))[step]
      if(DashboardCompetitionList.filter(d => ShouldDisplay(d)).length > 1) setCurrentDashboardState({})
      if(!isUndefined(fetchThisDashboard)) {
        dispatch(getDashboardCompetition(Userid, Afid, fetchThisDashboard.id))
      }
    }
    setActiveStep(step);
  };

  React.useEffect(() => {
    dispatch(getDashboardCompetitionList(Userid,Afid))
    dispatch(getArtikelTags(Afid,Userid))
  }, [])

  React.useEffect(() => {
    if(!isEmpty(currentDashboardCompetition)) setCurrentDashboardState(currentDashboardCompetition)
  },[currentDashboardCompetition, DashboardCompetitionLoading])

  React.useEffect(() => {
    if(!isEmpty(DashboardCompetitionList)) { 
      let fetchThisDashboard = DashboardCompetitionList.filter(d => ShouldDisplay(d))[0]
      if(!isUndefined(fetchThisDashboard)) {
        dispatch(getDashboardCompetition(Userid, Afid, fetchThisDashboard.id))
      }
    }
  }, [DashboardCompetitionList])

  const handleChangeStep = (stepChange) => {
    let __step = DashboardCompetitionList.filter(d => ShouldDisplay(d))[stepChange]

    if(!isUndefined(__step)) handleStepChange(stepChange)
    if(stepChange > activeStep && isUndefined(__step)) handleStepChange(0)
    if(stepChange < activeStep && isUndefined(__step)) handleStepChange(DashboardCompetitionList.filter(d => ShouldDisplay(d)).length-1)
  }

  const handleGetCompetition = (id) => {
    if(isUndefined(props.isFrom)){
    dispatch(getDashboardCompetition(Userid, Afid, id))
    history.push({pathname:"/app/DashboardTavling", state: {CompId: id}})
    }
  } 
  console.log(props,"props.isFrom")
  if(isEmpty(DashboardCompetitionList.filter(d => ShouldDisplay(d)))){
		return (
			<Card className={classes.tavlingBg} elevation={3}>
				<div className='d-flex align-items-center justify-content-center h-100 w-100'>
					<h1 className='m-0' style={{
						fontSize: 50, 
						fontWeight: 700,
						textAlign:'center',
						color: 'rgb(68, 209, 194)',
						['-webkit-text-stroke']: '2px rgb(84, 243, 227)'
						}}><IntlMessages id="DashBoard.NoActive.Compitations"/></h1>
				</div>
			</Card>
		)
	} 

  return (
    <Card className={classes.tavlingBg} elevation={3}>
      <span className="text">
      <div className="h-100 d-flex flex-column align-items-center postition-relative">
        <div className='h-100 w-100 position-relative d-flex flex-column' style={{top:0,left:0}}>
          <div className='text-white px-2 pt-1 font-weight-bold text-align-center d-flex align-items-center w-100 justify-content-between' style={{fontSize: 19}}>
            {
              DashboardCompetitionList.filter(d => ShouldDisplay(d)).length>1?
              <IconButton size="small" color="primary" onClick={() => handleChangeStep(activeStep-1)}>
                <ArrowBackIos/>
              </IconButton>:<div></div>
            }
            {
              !isUndefined(DashboardCompetitionList.filter(d => ShouldDisplay(d))[activeStep]) &&
              <Button size="small" color="primary" style={{
                /*fontSize: 18,*/
                whiteSpace: "nowrap",
                fontWeight:500, height:30}} className='text-white' onClick={() => handleGetCompetition(DashboardCompetitionList.filter(d => ShouldDisplay(d))[activeStep].id)}>{isEmpty(currentDashboardState) ? '' : currentDashboardState.Name}</Button>
            }
            {
              DashboardCompetitionList.filter(d => ShouldDisplay(d)).length>1?
              <IconButton size="small" color="primary" onClick={() => handleChangeStep(activeStep+1)}>
                <ArrowForwardIos/>
              </IconButton>:<div></div>
            }
          </div>
            <AutoPlaySwipeableViews
                interval={600000}
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                className='w-100'
                style={{flexGrow:1}}
                containerStyle={{height: "100%"}}
              >
                {
                  isRefreshed === true?"":
                  DashboardCompetitionList.filter(d => ShouldDisplay(d)).map((c, index) => {
                    return (
                      <DashBoardTavlingItem key={c.id} Competition={c} currentDashboardCompetition={currentDashboardState} handleStepChange={handleStepChange} listLength={DashboardCompetitionList.filter(d => ShouldDisplay(d)).length}/>
                    )
                  })
                }
            </AutoPlaySwipeableViews>
          </div>
        </div>
      </span>
    </Card>
  )
}
